import type { ReactNode } from "react";
import { classes } from "../../nucleo/classes";

export type TomDoAviso = "neutro" | "marca" | "atencao" | "erro" | "sucesso";

const CLASSES: Record<TomDoAviso, string> = {
  neutro: "",
  marca: "aviso--marca",
  atencao: "aviso--atencao",
  erro: "aviso--erro",
  sucesso: "aviso--sucesso",
};

const ICONES: Record<TomDoAviso, string> = {
  neutro: "→",
  marca: "→",
  atencao: "!",
  erro: "!",
  sucesso: "✓",
};

export interface PropsDoAviso {
  tom?: TomDoAviso;
  /** Substitui o ícone padrão do tom. */
  icone?: ReactNode;
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
}

/** O `.secnote` / `.alert` do protótipo: uma linha de consequência ao lado do formulário. */
export function Aviso({
  tom = "neutro",
  icone,
  children,
  className,
  ...resto
}: PropsDoAviso) {
  return (
    <div
      className={classes("aviso", CLASSES[tom], className)}
      // Erro e atenção são anunciados assim que aparecem; o resto é leitura passiva.
      role={tom === "erro" ? "alert" : "note"}
      {...resto}
    >
      <span className="aviso__icone" aria-hidden="true">
        {icone ?? ICONES[tom]}
      </span>
      <div>{children}</div>
    </div>
  );
}
